import React from 'react';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const RicosContext = React.createContext({
  locale: "en",
  experiments: {},
  isMobile: false,
  t: (text) => text,
  languageDir: "ltr",
  theme: {},
  portal: null,
  debugMode: [],
  platform: "macOs",
  content: null,
  jsdomMode: false
});
const RicosContextProvider = ({
  children,
  isMobile,
  locale,
  experiments,
  languageDir,
  theme,
  t,
  portal = null,
  editorExternalContainer = void 0,
  debugMode = [],
  jsdomMode = false,
  platform = "macOs",
  content = null
}) => {
  return /* @__PURE__ */ React.createElement(
    RicosContext.Provider,
    {
      value: {
        t,
        locale,
        isMobile,
        experiments,
        languageDir,
        theme,
        portal,
        debugMode,
        jsdomMode,
        editorExternalContainer,
        platform,
        content
      }
    },
    React.cloneElement(React.Children.only(children))
  );
};
function withRicosContext(Component) {
  return (props) => {
    return /* @__PURE__ */ React.createElement(RicosContext.Consumer, null, (value) => /* @__PURE__ */ React.createElement(Component, __spreadProps(__spreadValues({}, props), { ricosContext: value })));
  };
}
const RicosContextConsumer = ({ children }) => {
  return /* @__PURE__ */ React.createElement(RicosContext.Consumer, null, (value) => children(value));
};

export { RicosContext, RicosContextConsumer, RicosContextProvider, withRicosContext };
//# sourceMappingURL=RicosContext.js.map
